<div class="dropdown__row dropdown__row--gap-{{ gap }}">
  <ng-content></ng-content>
</div>
